module.exports = __webpack_public_path__ + "img/restaurant-12.5372e9e2.jpg";